import { __t } from "@core/translation/translation";

const menuItems = [
  {
    title: __t("Dashboard"),
    path: "/dashboard/profile",
    icon: "icon-home",
    fiil_icon: "icon-home-fill",
  },
  {
    title: __t("Market"),
    path: "/market/BTC-IRT",
    icon: "icon-stock-market",
    fiil_icon: "icon-stock-market-fill",
  },
  {
    title: __t("wallets"),
    path: "/wallet/wallets-list",
    icon: "icon-wallet",
    fiil_icon: "icon-wallet-fill",
  },
  {
    title: __t("Orders"),
    path: "/orders/active-orders",
    icon: "icon-file-text",
    fiil_icon: "icon-file-text-filled",
  },
  {
    title: __t("Market Order"),
    path: "/marketOrder/buy",
    icon: "icon-orde",
    fiil_icon: "icon-orde-fill",
  },
  {
    title: __t("Transaction History"),
    path: "/transaction-history/success",
    icon: "icon-buying",
    fiil_icon: "icon-buying-fill",
  },
  {
    title: __t("Settings"),
    path: "/settings/security",
    icon: "icon-settings",
    fiil_icon: "icon-setting-fill",
  },
];
export { menuItems };
